<template>
  <div class="">
    <portal to="toolbar-title"> Αιτήματα</portal>
    <portal to="toolbar-actions">
    </portal>
    <v-card color="transparent" >
      <v-toolbar flat dense>
        <v-toolbar-title>Αιτήματα</v-toolbar-title>
        <v-toolbar-items>
          <v-btn text color="primary" to="/addIssue"> NEO AITHMA</v-btn>
        </v-toolbar-items>
        <v-spacer/>
        <portal-target name="filters"/>
      </v-toolbar>
      <v-tabs @change="onModeChange">
        <v-tab> ΑΝΟΙΧΤΑ</v-tab>
        <v-tab> ΚΛΕΙΣΤΑ</v-tab>
        <v-tab-item>
          <portal to="filters">
            <filters-modal module-name="IssueHandler"/>
          </portal>
          <v-list max-height="70vh" class="overflow-y-auto">
            <v-list-item v-if="data.length === 0 ">
              <v-list-item-content>
                Δεν έχουν δημιουργηθεί αιτήματα ακόμα.
              </v-list-item-content>
            </v-list-item>
            <v-list-item-group class="pa-2" v-model="activeIndex">
              <issue-item @click="setIssue(i)" v-for="i in data" :item="i"/>
            </v-list-item-group>
          </v-list>
        </v-tab-item>
        <v-tab-item>
          <portal to="filters">
            <filters-modal module-name="ClosedIssueHandler"/>
          </portal>
          <v-list max-height="70vh" class="overflow-y-auto">
            <v-list-item v-if="closedIssuesData.length === 0 ">
              <v-list-item-content>
                Δεν υπάρχουν κλειστά αιτήματα
              </v-list-item-content>
            </v-list-item>
            <v-list-item-group class="pa-2" v-model="activeIndex">
              <issue-item @click="setIssue(i)" v-for="i in closedIssuesData" :item="i"/>
            </v-list-item-group>
          </v-list>
        </v-tab-item>
      </v-tabs>
    </v-card>
    <v-dialog v-model="modal" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card class="background">
        <v-toolbar dense tile dark class="secondary">
          <v-btn icon @click="modal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Μυνήματα Αιτήματος</v-toolbar-title>
        </v-toolbar>
        <issue-chat @issueClosed="onIssueClosed()" v-if="issue" :issue="issue"/>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import IssueItem from "../components/IssueListItem";
import store from "../../../store";
import DataGridHandler from "../../../wl-datagrid-handler/dataGridHandler";
import IssueChat from "../components/IssueChat";
import Filters from "../../../wl-datagrid-handler/Filters";
import backButton from "../../../wl-core/mixins/backButton";
import FiltersModal from "../../../wl-datagrid-handler/FiltersModal";
import issueMixin from "@/views/Issues/mixins/issueMixin";

export default {
  name: "IssuesMobile",
  components: {FiltersModal, Filters, IssueChat, IssueItem},
  mixins: [issueMixin, backButton(['modal'])],
  data: () => ({
    tab: 0,
  }),
  methods: {
    onIssueClosed() {
      this.resetSelectedOpenIssue();
    },
    onModeChange(tab) {
      this.activeIndex = 0;
      if (tab === 1) {
        this.getClosedIssues();
        this.setClosedIssues();
        this.resetSelectedClosedIssue();
        this.tab = 1;
      } else {
        this.resetSelectedOpenIssue()
        this.tab = 0;
      }
    }
  }

}
</script>

<style scoped>

</style>
